// registry.ts
import { assertSchema } from "./errors.mjs";
var _registry = {};
var registry = {
  /** Registers the specified validator constructor */
  set(key, constructor) {
    _registry[key] = constructor;
  },
  /** Retrieves the specified validator constructor */
  get(key) {
    const value = _registry[key];
    assertSchema(!!value, `No validator found for "${key}"`);
    return value;
  }
};
export {
  registry
};
//# sourceMappingURL=registry.mjs.map
